import React from "react";
import { caApi } from "../../../../../backend_urls/caApi";
import DynamicTable from "../../../../../components/reusable/DynamicTable";
import StatusBadge from "../../../../../utils/StatusBadge";
import Avatar from "../../../../../components/reusable/Avatar";

const EmployeeTable = ({
    employees = [],
    loading = false,
    onViewEmployee,
    onLoadData,
}) => {
    const employeeColumns = [
        {
            key: "employee",
            label: "Employee",
            sortable: true,
            render: (_, row) => (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                    }}
                >
                    <Avatar
                        image = { row.profile_image }
                        name  = { row.user_full_name_display || row.user_email }
                        size  = "sm"
                    />

                    <div>
                        <div style={{ fontWeight: 600 }}>
                            {row.user_full_name_display || "Unnamed Employee"}
                        </div>

                        <div style={{ fontSize: "13px", color: "#64748b" }}>
                            {row.user_email || "—"}
                        </div>
                    </div>
                </div>
            ),
        },

        {
            key: "employee_code",
            label: "Employee Code",
            sortable: true,
            render: (value) => value || "-",
        },

        {
            key: "designation",
            label: "Designation",
            sortable: true,
            render: (value) => value || "-",
        },

        {
            key: "department_name",
            label: "Department",
            sortable: true,
            render: (value) => value || "-",
        },

        {
            key: "office_name",
            label: "Office",
            sortable: true,
            render: (value) => value || "-",
        },

        {
            key: "status",
            label: "Status",
            sortable: true,
            render: (status) => ( <StatusBadge status={status} /> ),
        },
    ];

    const dropDownOptions = (employeeId) => [
        {
            label: "Activate",
            onClick: async () => {
                await caApi.activateEmployee(employeeId);
                await onLoadData?.();
            },
        },
        {
            label: "De-Activate",
            onClick: async () => {
                await caApi.deactivateEmployee(employeeId);
                await onLoadData?.();
            },
        },
    ];

    const actions = [
        {
            buttonType: "editIcon",
            onClick: (employee) => { onViewEmployee?.(employee); },
        },
        {
            buttonType: "moreOptions",
            getDropdownOptions: (employee) => dropDownOptions(employee.id),
        },
    ];

    if (loading) {
        return (
            <div style={{ padding: "24px", textAlign: "center" }}>
                Loading employees...
            </div>
        );
    }

    if (!employees.length) {
        return (
            <div style={{ padding: "24px", textAlign: "center" }}>
                No employees found.
            </div>
        );
    }

    return (
        <DynamicTable
            columns  = { employeeColumns }
            data     = { employees }
            onAction = { actions }
        />
    );
};

export default EmployeeTable;
